import award2018Logo from '@/Framework/assets/awards/award2018.webp';
import award2019Logo from '@/Framework/assets/awards/award2019.webp';
import award2022Logo from '@/Framework/assets/awards/award2022.webp';
import award2023Logo from '@/Framework/assets/awards/award2023.webp';
import award2024Logo from '@/Framework/assets/awards/award2024.webp';

export const awardsTitle = 'An Award-Winning Platform for Capital Markets';

export const awardDescription = `
  FINSIGHT continues to receive recognition as a leading US Securitization data provider in an annual industry poll
hosted by GlobalCapital.
`;

export const awardsCollection = [
  {
    key: '2024',
    logo: award2024Logo,
    text: 'Securitization Tech\n Provider of the Year',
    alt: '2024',
  },
  {
    key: '2023',
    logo: award2023Logo,
    text: 'Securitization Trading Data\n Provider of the Year',
    alt: '2023',
  },
  {
    key: '2022',
    logo: award2022Logo,
    text: 'Securitization Trading Data\n Provider of the Year',
    alt: '2022',
  },
  {
    key: '2019',
    logo: award2019Logo,
    text: 'Securitization Tech\n Provider of the Year',
    alt: '2019',
  },
  {
    key: '2018',
    logo: award2018Logo,
    text: 'ABS Data\n Provider of the Year',
    alt: '2018',
  },
];
